<script setup>
import { ref } from 'vue';
import { useStore } from 'dashboard/composables/store';
import { useAlert } from 'dashboard/composables';
import { useI18n } from 'vue-i18n';
import { parseAPIErrorResponse } from 'dashboard/store/utils/api';

import Dialog from 'dashboard/components-next/dialog/Dialog.vue';
import KnowledgeBaseDocumentForm from '../knowledgeBaseDocument/KnowledgeBaseDocumentForm.vue';

defineProps({
  knowledgeBaseId: {
    type: Number,
    required: true,
  },
});

const emit = defineEmits(['close', 'success']);
const { t } = useI18n();
const store = useStore();

const dialogRef = ref(null);
const createdDocument = ref(null);

const i18nKey = 'PILOT.KNOWLEDGE_BASES.DOCUMENTS';

const handleSubmit = async newDocument => {
  try {
    const result = await store.dispatch('pilotDocuments/create', newDocument);
    createdDocument.value = result;
    useAlert(t(`${i18nKey}.CREATE_SUCCESS`));
    emit('success', result);
    dialogRef.value.close();
  } catch (error) {
    const errorMessage =
      parseAPIErrorResponse(error) || t(`${i18nKey}.CREATE_ERROR`);
    useAlert(errorMessage);
  }
};

const handleClose = () => {
  // 只发出 close 事件，不发出 success
  emit('close', createdDocument.value);
};

const handleCancel = () => {
  dialogRef.value.close();
};

defineExpose({ dialogRef });
</script>

<template>
  <Dialog
    ref="dialogRef"
    :title="$t(`${i18nKey}.CREATE_TITLE`)"
    :description="$t(`${i18nKey}.CREATE_DESCRIPTION`)"
    :show-cancel-button="false"
    :show-confirm-button="false"
    @close="handleClose"
  >
    <KnowledgeBaseDocumentForm
      :knowledge-base-id="knowledgeBaseId"
      @submit="handleSubmit"
      @cancel="handleCancel"
    />
    <template #footer />
  </Dialog>
</template>
